module.exports = "/img/_/_/_/assets/images/creeper/battle/common//25.jpg?c9d595db3ec63868b166aaad50e377b9";